import { FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';
import * as React from 'react';

export const EMPTY_SPACER_KEY = 'Spacer';

export function getEmptySpacerItem(): FilterableMenuItem {
    return new FilterableMenuItem({
        [FilterableMenuItemArgs.key]: EMPTY_SPACER_KEY,
        [FilterableMenuItemArgs.name]: '',
        // defining custom onRender with empty div so that the item is not default-rendered as a focusable button element
        [FilterableMenuItemArgs.onRender]: () => <div />,
    });
}
